import {BaseApp} from "@/shared/BaseApp";
import {StyledBoxColumn} from "@/shared/StyledComponents";
import {Typography} from "@mui/material";
import Lottie from "lottie-react";
import {Action} from "@/shared/types";
import React from "react";
import doneAnim from "../res/anim/done.json";

export class TaskDoneHelper {

  private constructor() {
  }

  static showDoneDialog(): void {
    BaseApp.CONTEXT.showCustomDialog("You're all set", <StyledBoxColumn
        style={{alignItems: "center"}}>
        <Typography>You have completed all cases in this task.</Typography>
        <Lottie animationData={doneAnim} loop={false}/>
      </StyledBoxColumn>,
      new Action("OK", () => {
      }));
  }
}